module.exports = __webpack_public_path__ + "static/project4-c4dee2487492dc5495e80a30ceaa6097.jpg";